import { getButtonsWithTextBoxTemplate, getButtonsWithTextBoxVueTemplate } from "../../shortcodes/templates";

const visualizeButtonsWithTextBox = content => {
  const shortcodes = content.querySelectorAll('[data-wrapper-id="buttons-with-text-box-shortcode"]');
  if (shortcodes.length > 0) {
    shortcodes.forEach(item => {
      const vueItem = item.querySelector("buttons-with-text-box");
      const data = vueItem.getAttribute("data");
      const buttonArray = vueItem.getAttribute("buttons-array");
      const boxArray = vueItem.getAttribute("box-array");

      if (data) {
        item.innerHTML = getButtonsWithTextBoxTemplate(
          JSON.parse(window.atob(data)),
          JSON.parse(window.atob(buttonArray)),
          JSON.parse(window.atob(boxArray)),
        );
      }
    });
  }
};

const serializeButtonsWithTextBox = content => {
  const shortcodes = content.querySelectorAll('[data-wrapper-id="buttons-with-text-box-shortcode"]');
  if (shortcodes.length > 0) {
    shortcodes.forEach(item => {
      const data = item.getAttribute("data-buttons-with-text-box-data");
      const buttonsHtml = item.querySelectorAll(".button-with-text-box-link");
      let buttonArray = [];
      buttonsHtml.forEach(buttonHtml => {
        buttonArray.push(buttonHtml.innerHTML);
      });

      const boxesHtml = item.querySelectorAll(".button-with-text-box-text");
      let boxArray = [];
      boxesHtml.forEach(boxHtml => {
        let index = boxHtml.getAttribute("data-button-index");
        boxArray[index] = boxHtml.innerHTML;
      });

      item.innerHTML = getButtonsWithTextBoxVueTemplate(
        data,
        btoa(JSON.stringify(buttonArray)),
        btoa(JSON.stringify(boxArray)),
      );
    });
  }
};

export { visualizeButtonsWithTextBox, serializeButtonsWithTextBox };
